if (!wpi) {
  var wpi = {};
}

if (!wpi.mapmodule) {
  wpi.mapmodule = {};
}




// SENDING EVENTS TO ELM

wpi.mapmodule.onMapCreated = function(map) {
  var mapData = wpi.mapmodule.getMapDataObj(map);
  elmApp.ports.mapCreated.send(mapData);
};


wpi.mapmodule.onGeolocErrored = function(geolocErr) {
  elmApp.ports.geolocErrored.send(geolocErr);
};


wpi.mapmodule.onCurPosDataReceived = function(curPosData) {
  elmApp.ports.curPosDataReceived.send(curPosData);
};


wpi.mapmodule.onCurPosDataErrored = function(err) {
  elmApp.ports.curPosDataErrored.send(err);
};


wpi.mapmodule.createPtAtCurPosAndSend = function(layerKey, curPosData, geomData) {
  const ptAtCurPosData =
  { geomData: geomData,
    curPosData: curPosData
  }
  elmApp.ports.ptDrawnFromCurPos.send(ptAtCurPosData);
};


wpi.mapmodule.listenToClick = function(map) {
  map.on('click', function(evt) {
    wpi.mapmodule.sendClickData(map, evt.coordinate, false);
  });
};


wpi.mapmodule.listenToMapMove = function(map) {
  map.on('moveend', function(evt) {
    var mapData = wpi.mapmodule.getMapDataObj(map);
    elmApp.ports.mapMoved.send(mapData);
  });
};


wpi.mapmodule.listenToPointerMove = function(map) {
  map.on('pointermove', function(evt) {
    elmApp.ports.mapPointerMoved.send({ x: evt.coordinate[0], y: evt.coordinate[1] });
  });
};


wpi.mapmodule.onLegendCreated = function(layerKey, legend) {
  if (!legend) return;
  elmApp.ports.legendCreated.send({ layerKey: layerKey, legend: legend });
};


wpi.mapmodule.onSelectionUpdated = function(features) {
  var featuresData = [];
  for (var i=0; i<features.length; i++) {
    var feature = features[i];
    var id = "";
    if (feature.getId()) {
      id = feature.getId().toString();
    }
    featuresData.push({
      layerKey: feature.layerKey,
      id: id,
      data: feature.wpimodel,
      rootId: (feature.wpiParentId || feature.getId() || "").toString(),
      rootData: feature.wpiParentModel || feature.wpimodel
    });
  }
  elmApp.ports.selectionUpdated.send(featuresData);
};


wpi.mapmodule.onDrawDone = function (layerKey, feature, id) {
  if (id) {
    feature.setId(id); //Useful to possibly retrieve later, as for removing after splitting
  }
  var writer = new ol.format.GeoJSON(); //Only Geojson supported for now
  var geomData = {
    layerKey: layerKey,
    geom: writer.writeGeometryObject(feature.getGeometry())
  };
  elmApp.ports.geomDrawn.send(geomData);
};


wpi.mapmodule.onModifsUpdated = function(layerKey, features) {
  var featuresData = [];
  var writer = new ol.format.GeoJSON(); //Only Geojson supported for now
  for (var i=0; i<features.length; i++) {
    var feature = features[i];
    feature.wpimodel.geometry = writer.writeGeometryObject(feature.getGeometry()); //Update geom in model
    featuresData.push({
      id: feature.getId().toString(),
      data: feature.wpimodel,
      rootId: (feature.wpiParentId || feature.getId() || "").toString(),
      rootData: feature.wpiParentModel || feature.wpimodel
    });
  }
  elmApp.ports.modifsUpdated.send({ layerKey: layerKey, features: featuresData });
};


wpi.mapmodule.onMergeEnded = function(mergedObj) {
  elmApp.ports.mergeReceived.send(mergedObj);
};


wpi.mapmodule.onSplitEnded = function(splitObjs) {
  elmApp.ports.splitReceived.send(splitObjs);
};


wpi.mapmodule.onBreakupEnded = function(breakupObjs) {
  elmApp.ports.breakupReceived.send(breakupObjs);
};


wpi.mapmodule.sendGeoZoneNotAllowed = function() {
  elmApp.ports.modeErrorReceived.send("mapmodule_geozone_not_allowed");
};


wpi.mapmodule.sendModeError = function(err) {
  elmApp.ports.modeErrorReceived.send(err);
};


wpi.mapmodule.sendNoError = function() {
  elmApp.ports.modeErrorReceived.send(null);
};


wpi.mapmodule.sendCoordInZonesChecked = function(elmdata) {
  elmApp.ports.coordInZonesChecked.send(elmdata);
};


wpi.mapmodule.sendCapturedCanvas = function(elmdata) {
  elmApp.ports.capturedCanvasReceived.send(elmdata);
};




// HELPERS

wpi.mapmodule.sendClickData = function(map, coord, isUpdate) {
  if (!coord) return;

  //If a mode is active, abort
  if (map.editInteractions && map.editInteractions.length != 0) return;
  if (map.selectInteraction) return;

  //Save the click location
  map.lastClickCoords = coord;

  //Get all features at click location
  var pixPos = map.getPixelFromCoordinate(coord);
  if (!pixPos) return;

  // Get the features under click
  var dataUnderClick = [];
  map.forEachFeatureAtPixel(pixPos, function(feature, layer) {
    if (layer) { //To prevent a layer null ol bug?

      var clusteredFeatures = feature.get('features');

      // If not a cluster, just take the simple feature
      if (!clusteredFeatures) {
        wpi.mapmodule.addFeatureToDataUnderClic(dataUnderClick, layer, feature);
      }

      // If cluster and several features, only return if parametrised
      else if (clusteredFeatures && clusteredFeatures.length > 1) {
        if (!layer.clusterObjsReturnedOnClick) {
          // Don't get objects in cluster
        } else {
          var featuresToReturnNb;
          if (layer.clusterObjsReturnedOnClick == -1) { //-1 is to specify no limit nb
            featuresToReturnNb = clusteredFeatures.length
          } else { //Take only the specified number or all features if less than specified number
            featuresToReturnNb = Math.min(clusteredFeatures.length, layer.clusterObjsReturnedOnClick) || 0; //||0 in case wrong
          }
          for (var i=0; i<featuresToReturnNb; i++) {
            wpi.mapmodule.addFeatureToDataUnderClic(dataUnderClick, layer, clusteredFeatures[i]);
          }
        }
      }

      //Just one feature in cluster (not a cluster anymore): take it
      else if (clusteredFeatures && clusteredFeatures.length === 1) {
        wpi.mapmodule.addFeatureToDataUnderClic(dataUnderClick, layer, clusteredFeatures[0]);
      }

    }
  });

  //Send the data to elm
  elmApp.ports.mapClickDataReceived.send(
    {
      isUpdate : isUpdate,
      coordinate: { x: coord[0], y: coord[1] },
      pixelPos: { x: pixPos[0], y: pixPos[1] },
      featuresData: dataUnderClick
    }
  );
};



wpi.mapmodule.addFeatureToDataUnderClic = function(dataUnderClick, layer, feature) {
  var id = "";
  if (feature.getId()) {
    id = feature.getId().toString();
  }
  dataUnderClick.push({
    layerKey: layer.key,
    id: id,
    data: feature.wpimodel,
    rootId: (feature.wpiParentId || feature.getId() || "").toString(),
    rootData: feature.wpiParentModel || feature.wpimodel
  });
};


wpi.mapmodule.getMapDataObj = function(map) {
  var clickPixPos = null;
  if (map.lastClickCoords) {
    var pos = map.getPixelFromCoordinate(map.lastClickCoords);
    clickPixPos = { x: pos[0], y: pos[1] };
  }
  var ext = map.getView().calculateExtent(map.getSize());
  return {
    map : map,
    extent: { minx: ext[0], miny: ext[1], maxx: ext[2], maxy: ext[3] },
    resolution: map.getView().getResolution(),
    clickPixelPos : clickPixPos
  };
};
